/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { ItemCalculationFragmentDoc, WithDocumentItemTaskInfoFragmentDoc, WithItemPropertiesFragmentDoc, WithProductInfoFragmentDoc, WithDocumentItemCalculationFragmentDoc, DocumentItem_CalculationsFragmentDoc, WithProductFiltersInfoFragmentDoc, ItemProductPlaceholderFragmentDoc, FieldsAffectedByAttributeExpressionsFragmentDoc, TreeItem__DocumentItemFragmentDoc, TreeItemTemplatePlaceholderFragmentDoc, WithDocumentItemInfoFragmentDoc, WithDocumentItemTreeInfoFragmentDoc, WithDocumentItemVisibilityInfoFragmentDoc, WithDocumentItemChangeOrderInfoFragmentDoc, WithDocumentItemAgreementInfoFragmentDoc, WithDocumentItemDecisionInfoFragmentDoc, ItemProductFieldsFragmentDoc } from '../Fragments.generated.js';
import { DocumentStatus_DocumentFragmentDoc, DocumentInterpolatedTexts_DocumentFragmentDoc, ProposedCalculations_ItemFragmentDoc } from './useDecisionItemMutations.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ItemOrSubItemsPropsUsedInOtherItemsQueryVariables = Types.Exact<{
  projectId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  docId: Types.Scalars['ID']['input'];
  itemId: Types.Scalars['ID']['input'];
  skipSubtree?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type ItemOrSubItemsPropsUsedInOtherItemsQuery = { itemOrSubItemsPropsUsedInOtherItems: { __typename: 'ItemOrSubItemsPropsUsedInOtherItemsResult', used: boolean } | { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } };

export type DeleteDocumentItemMutationVariables = Types.Exact<{
  input: Types.DeleteItemInput;
}>;


export type DeleteDocumentItemMutation = { deleteItem: { __typename: 'DeleteItemResult', doc: { __typename: 'Building', id: string, items: Array<{ __typename: 'Item', id: string, originVersionNumber?: number | null, rank: number, pathForPdf: string }> } | { __typename: 'Quote', id: string, isPublished: boolean, isBinding: boolean, needsAgreement: boolean, agreement: Types.Agreement, items: Array<{ __typename: 'Item', id: string, originVersionNumber?: number | null, rank: number, pathForPdf: string, deletedAt?: any | null, needsAgreement: boolean, pendingChangeAttributes: any }>, proposedCalculation?: { __typename: 'ItemCalculation', materialBuyingPricePerUnit: number, discountRate: number, materialMargin: number, materialPriceDiscountedSubTotal: number, materialPricePerUnit: number, materialPriceSubTotal: number, materialFactor: number, priceNetTotal: number, pricePerUnit: number, priceSubTotal: number, priceTotal: number, priceVatTotal: number, quantity: number, quantityUnit: Types.QuantityUnit, timePerUnit: number, timeTotal: number, workSellingRate: number, workBuyingRate: number, workRate: number, workBuyingPricePerUnit: number, workPriceDiscountedSubTotal: number, workPricePerUnit: number, workPriceSubTotal: number, workFactor: number, vatRate: number } | null, interpolatedQuoteTexts?: { __typename: 'QuoteTexts', id: string, opening: string, closing: string } | null } | { __typename: 'QuoteTemplate', id: string, resolvedAsReadModelVersionNumber?: number | null, accessType: Types.TemplateAccessType, owningSystemOrganisationId: string, hasAnyPublishedVersion: boolean, containsUnpublishedChanged: boolean, items: Array<{ __typename: 'Item', id: string, originVersionNumber?: number | null, rank: number, pathForPdf: string }>, previewItems: Array<{ __typename: 'Item', id: string, originVersionNumber?: number | null, rank: number, pathForPdf: string }>, proposedCalculation?: { __typename: 'ItemCalculation', materialBuyingPricePerUnit: number, discountRate: number, materialMargin: number, materialPriceDiscountedSubTotal: number, materialPricePerUnit: number, materialPriceSubTotal: number, materialFactor: number, priceNetTotal: number, pricePerUnit: number, priceSubTotal: number, priceTotal: number, priceVatTotal: number, quantity: number, quantityUnit: Types.QuantityUnit, timePerUnit: number, timeTotal: number, workSellingRate: number, workBuyingRate: number, workRate: number, workBuyingPricePerUnit: number, workPriceDiscountedSubTotal: number, workPricePerUnit: number, workPriceSubTotal: number, workFactor: number, vatRate: number } | null, templateSharing?: { __typename: 'TemplateSharing', id: string, latestSharedVersionNumber: number, sharedPublicly: boolean, subscribedToTemplate?: { __typename: 'TemplateSubscription', subscribedVersionNumber: number, updateAvailable: boolean } | null } | null } | { __typename: 'Requirement', id: string, isPublished: boolean, items: Array<{ __typename: 'Item', id: string, originVersionNumber?: number | null, rank: number, pathForPdf: string }>, proposedCalculation?: { __typename: 'ItemCalculation', materialBuyingPricePerUnit: number, discountRate: number, materialMargin: number, materialPriceDiscountedSubTotal: number, materialPricePerUnit: number, materialPriceSubTotal: number, materialFactor: number, priceNetTotal: number, pricePerUnit: number, priceSubTotal: number, priceTotal: number, priceVatTotal: number, quantity: number, quantityUnit: Types.QuantityUnit, timePerUnit: number, timeTotal: number, workSellingRate: number, workBuyingRate: number, workRate: number, workBuyingPricePerUnit: number, workPriceDiscountedSubTotal: number, workPricePerUnit: number, workPriceSubTotal: number, workFactor: number, vatRate: number } | null }, parentItem?: { __typename: 'Item', id: string, originVersionNumber?: number | null, hasChildren: boolean, children: Array<{ __typename: 'Item', id: string, originVersionNumber?: number | null }> } | null, parentPathItems: Array<{ __typename: 'Item', id: string, originVersionNumber?: number | null, proposedCalculation?: { __typename: 'ItemCalculation', materialBuyingPricePerUnit: number, discountRate: number, materialMargin: number, materialPriceDiscountedSubTotal: number, materialPricePerUnit: number, materialPriceSubTotal: number, materialFactor: number, priceNetTotal: number, pricePerUnit: number, priceSubTotal: number, priceTotal: number, priceVatTotal: number, quantity: number, quantityUnit: Types.QuantityUnit, timePerUnit: number, timeTotal: number, workSellingRate: number, workBuyingRate: number, workRate: number, workBuyingPricePerUnit: number, workPriceDiscountedSubTotal: number, workPricePerUnit: number, workPriceSubTotal: number, workFactor: number, vatRate: number } | null }>, otherChangedItems: Array<{ __typename: 'Item', id: string, originVersionNumber?: number | null, pathForPdf: string }> } };


export const ItemOrSubItemsPropsUsedInOtherItemsDocument = gql`
    query ItemOrSubItemsPropsUsedInOtherItems($projectId: ID, $docId: ID!, $itemId: ID!, $skipSubtree: Boolean) {
  itemOrSubItemsPropsUsedInOtherItems(
    projectId: $projectId
    docId: $docId
    itemId: $itemId
    skipSubtree: $skipSubtree
  ) {
    ... on ItemOrSubItemsPropsUsedInOtherItemsResult {
      used
    }
  }
}
    `;

/**
 * __useItemOrSubItemsPropsUsedInOtherItemsQuery__
 *
 * To run a query within a React component, call `useItemOrSubItemsPropsUsedInOtherItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemOrSubItemsPropsUsedInOtherItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemOrSubItemsPropsUsedInOtherItemsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      docId: // value for 'docId'
 *      itemId: // value for 'itemId'
 *      skipSubtree: // value for 'skipSubtree'
 *   },
 * });
 */
export function useItemOrSubItemsPropsUsedInOtherItemsQuery(baseOptions: Apollo.QueryHookOptions<ItemOrSubItemsPropsUsedInOtherItemsQuery, ItemOrSubItemsPropsUsedInOtherItemsQueryVariables> & ({ variables: ItemOrSubItemsPropsUsedInOtherItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemOrSubItemsPropsUsedInOtherItemsQuery, ItemOrSubItemsPropsUsedInOtherItemsQueryVariables>(ItemOrSubItemsPropsUsedInOtherItemsDocument, options);
      }
export function useItemOrSubItemsPropsUsedInOtherItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemOrSubItemsPropsUsedInOtherItemsQuery, ItemOrSubItemsPropsUsedInOtherItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemOrSubItemsPropsUsedInOtherItemsQuery, ItemOrSubItemsPropsUsedInOtherItemsQueryVariables>(ItemOrSubItemsPropsUsedInOtherItemsDocument, options);
        }
export function useItemOrSubItemsPropsUsedInOtherItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ItemOrSubItemsPropsUsedInOtherItemsQuery, ItemOrSubItemsPropsUsedInOtherItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ItemOrSubItemsPropsUsedInOtherItemsQuery, ItemOrSubItemsPropsUsedInOtherItemsQueryVariables>(ItemOrSubItemsPropsUsedInOtherItemsDocument, options);
        }
export type ItemOrSubItemsPropsUsedInOtherItemsQueryHookResult = ReturnType<typeof useItemOrSubItemsPropsUsedInOtherItemsQuery>;
export type ItemOrSubItemsPropsUsedInOtherItemsLazyQueryHookResult = ReturnType<typeof useItemOrSubItemsPropsUsedInOtherItemsLazyQuery>;
export type ItemOrSubItemsPropsUsedInOtherItemsSuspenseQueryHookResult = ReturnType<typeof useItemOrSubItemsPropsUsedInOtherItemsSuspenseQuery>;
export type ItemOrSubItemsPropsUsedInOtherItemsQueryResult = Apollo.QueryResult<ItemOrSubItemsPropsUsedInOtherItemsQuery, ItemOrSubItemsPropsUsedInOtherItemsQueryVariables>;
export const DeleteDocumentItemDocument = gql`
    mutation DeleteDocumentItem($input: DeleteItemInput!) {
  deleteItem(input: $input) {
    doc {
      ... on WithDocumentInfo {
        id
      }
      ... on QuoteTemplate {
        resolvedAsReadModelVersionNumber
        items {
          id
          originVersionNumber
          rank
          pathForPdf
        }
        previewItems: items {
          id
          originVersionNumber
          rank
          pathForPdf
        }
      }
      ... on Quote {
        items {
          id
          originVersionNumber
          rank
          pathForPdf
          deletedAt
          needsAgreement
          pendingChangeAttributes
        }
      }
      ... on Requirement {
        items {
          id
          originVersionNumber
          rank
          pathForPdf
        }
      }
      ... on Building {
        items {
          id
          originVersionNumber
          rank
          pathForPdf
        }
      }
      ... on WithCalculation {
        proposedCalculation {
          ...ItemCalculation
        }
      }
      ...DocumentStatus_Document
      ...DocumentInterpolatedTexts_Document
    }
    parentItem {
      id
      originVersionNumber
      hasChildren
      children {
        id
        originVersionNumber
      }
    }
    parentPathItems {
      id
      originVersionNumber
      ...ProposedCalculations_Item
    }
    otherChangedItems {
      id
      originVersionNumber
      pathForPdf
    }
  }
}
    ${ItemCalculationFragmentDoc}
${DocumentStatus_DocumentFragmentDoc}
${DocumentInterpolatedTexts_DocumentFragmentDoc}
${ProposedCalculations_ItemFragmentDoc}`;
export type DeleteDocumentItemMutationFn = Apollo.MutationFunction<DeleteDocumentItemMutation, DeleteDocumentItemMutationVariables>;

/**
 * __useDeleteDocumentItemMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentItemMutation, { data, loading, error }] = useDeleteDocumentItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteDocumentItemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDocumentItemMutation, DeleteDocumentItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDocumentItemMutation, DeleteDocumentItemMutationVariables>(DeleteDocumentItemDocument, options);
      }
export type DeleteDocumentItemMutationHookResult = ReturnType<typeof useDeleteDocumentItemMutation>;
export type DeleteDocumentItemMutationResult = Apollo.MutationResult<DeleteDocumentItemMutation>;
export type DeleteDocumentItemMutationOptions = Apollo.BaseMutationOptions<DeleteDocumentItemMutation, DeleteDocumentItemMutationVariables>;